import { render, staticRenderFns } from "./icon-svg.vue?vue&type=template&id=7d01032f&scoped=true&"
var script = {}
import style0 from "./icon-svg.vue?vue&type=style&index=0&id=7d01032f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d01032f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d01032f')) {
      api.createRecord('7d01032f', component.options)
    } else {
      api.reload('7d01032f', component.options)
    }
    module.hot.accept("./icon-svg.vue?vue&type=template&id=7d01032f&scoped=true&", function () {
      api.rerender('7d01032f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/icon/icon-svg.vue"
export default component.exports